import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { observer } from 'mobx-react-lite';
import React, { useContext, useState } from 'react';
import MobxContext from '../../../mobx/MobxContext';

interface Props {
    defaultFamilyId: string;
    defaultFamilyName: string;
    onClose: () => void;
    onSubmit: (familyId: string) => void;
}

function WorkflowCloneDialog(props: Props) {
    const { defaultFamilyId, defaultFamilyName, onClose, onSubmit } = props;
    const [selectedFamily, setSelectedFamily] = useState({
        id: defaultFamilyId,
        name: defaultFamilyName
    });
    const { familyStore } = useContext(MobxContext);

    const onFamilyChange = (event: React.ChangeEvent<{}>, value: any) => {
        setSelectedFamily(value);
    };

    return (
        <Dialog
            open={true}
            onClose={onClose}
            aria-labelledby="clone-dialog-title"
            aria-describedby="clone-dialog-description"
        >
            <DialogTitle id="clone-dialog-title">{"Select a family for the new workflow"}</DialogTitle>
            <DialogContent>
                {familyStore.families && <Autocomplete
                    options={familyStore.families}
                    value={selectedFamily || null}
                    getOptionLabel={(option) => option.name}
                    onChange={onFamilyChange}
                    getOptionSelected={(option, value) => value ? option.id === value.id : false}
                    renderInput={(params) => <TextField
                        {...params}
                        label='Family'
                        InputLabelProps={{
                            shrink: true
                        }} />}
                />}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
                <Button disabled={!selectedFamily} onClick={() => onSubmit(selectedFamily.id)} color="primary" autoFocus>
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default observer(WorkflowCloneDialog);